import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(value) {
  if (value == null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

export const CATEGORY_LABELS = {
  sauna: "Saunas",
  "cold-plunge": "Cold Plunges",
  "hot-tub": "Hot Tubs",
  accessory: "Accessories",
  heater: "Heaters",
};
